import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notification";
import AdminApi from "../../../api/AdminApi";

type State = {
    data: { target: number };
    isLoading: boolean;
    isUpdating: boolean;
    error: Object | null;
    timestamp: number;
    isDirty: boolean;
};

const initialState = {
    data: { target: 0 },
    isLoading: true,
    isUpdating: false,
    error: null,
    timestamp: 0,
    isDirty: false
};

const goalConfiguration = createSlice({
    name: "goalConfiguration",
    initialState,
    reducers: {
        fetchGoalConfigurationStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
            state.isDirty = false;
        },
        fetchGoalConfigurationSuccess: (state: State, action) => {
            state.data = action.payload;
            if (action.payload.metricType === "totalReadingTime") {
                // convert seconds to hours
                state.data.target = action.payload.target / 3600;
            }

            state.isLoading = false;
            state.error = null;
            state.timestamp = Date.now();
        },
        fetchGoalConfigurationFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

// Actions
export const {
    fetchGoalConfigurationStart,
    fetchGoalConfigurationSuccess,
    fetchGoalConfigurationFailed,
} = goalConfiguration.actions;

export default goalConfiguration.reducer;

// Thunk
export const fetchGoalConfiguration = (id: any) => async (dispatch: Function) => {
    try {
        dispatch(fetchGoalConfigurationStart());
        const api = new AdminApi();
        const result = await api.getGoalConfiguration(id);
        dispatch(fetchGoalConfigurationSuccess(result));
    } catch (err: any) {
        dispatch(fetchGoalConfigurationFailed(err));
        dispatch(showNotification("error", err.message));
    }
};
